$(function () {
    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    //accept the cookies and set it
    $(document).on("click", "#accept-cookies", function () {
        $(".cookies").addClass("d-none");

        let setCookies = getCookie("lestari_capital_cookies");
        if (setCookies != "") {
            //console.log("the cookies is " + setCookies);
        } else {
            //setCookies = prompt("name of cookies:","");
            setCookies = "lestari_capital_cookies";
            if (setCookies != "" && setCookies != null) {
                setCookie("lestari_capital_cookies", setCookies, 30);
            }
        }
    });

    function checkCookie() {
        let theCookiesCheck = getCookie("lestari_capital_cookies");
        if (theCookiesCheck != "") {
            //console.log("the cookies is " + theCookiesCheck);
            $(".cookies").addClass("d-none");
        } else {
            //console.log("the cookies is ? " + theCookiesCheck);
            $(".cookies").removeClass("d-none");
        }
    }

    checkCookie();
});
